import Prism from "prismjs";
import 'prismjs/components/prism-json';
export var xml = function (text) { return Prism.highlight(text, Prism.languages.xml, "xml"); };
export var json = function (text) { return Prism.highlight(text, Prism.languages.json, "json"); };
